module.exports = __webpack_public_path__ + "img/howtoplay-05.5385c70e.jpg";